/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class UiAvatarComponent extends Component {
  @tracked imageAvailable = true;
}
